import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './Withdrawal.module.css';
import { Footer } from '../../../../../components';
import { Button } from '../../../../../components/v3';
import { useModal } from '../../../../../components/modalController/useModal';
import { SubmitConfirmModal } from '../../../../../components/ConfirmModal/SubmitConfirmModal';
import { useNavigate,useLocation } from 'react-router-dom';
import { useRecoilState, useRecoilValue} from 'recoil';
import { applicationsList, capitalFacilityState, getWithdrawalQuoteQuery, withdrawalAmountState,userEmail, useIsMobile } from '../../../../../recoil';
import { postCapitalFacilityWithdrawalQuote } from '../../../../../api/vodaLend';
import { useLoader } from '../../../../../components/Loader/useLoader';
import { useTealium } from '../../../../../tealium/useTealium';
import {WithdrawalInfoSection} from './components/WithdrawalInfoSection';
import {FundingDetailsAccordion} from './components/FundingDetailsAccordion';
import {RepaymentScheduleAccordion} from './components/RepaymentScheduleAccordion';

const MIN_WITHDRAWAL_AMT = 1000;

export const Withdrawal = () => {
  const { businessId, applicationId } = useParams();
  // eslint-disable-next-line no-unused-vars
  const [cfDetails,setCfDetails] = useRecoilState(capitalFacilityState({ businessId, applicationId }));

  const [openModal, closeModal, modal] = useModal();
  const [openLoader, closeLoader] = useLoader();
  const [isOpenConfirm, setOpenConfirm] = useState(false);
  const email = useRecoilValue(userEmail);
  const [openSection, setOpenSection] = useState('');
  const navigate = useNavigate();
  const amtToWithdraw = useRecoilValue(withdrawalAmountState);
  const amtToWithdrawResp = useRecoilValue(
    getWithdrawalQuoteQuery({ amount: amtToWithdraw, businessId, applicationId })
  );
  const [appsList, setAppList] = useRecoilState(applicationsList);
  const location = useLocation();
  const isMobile = useRecoilValue(useIsMobile);

  const { track, events } = useTealium();

  useEffect(() => {
    track(events.creditFacilityWithdrawl.pageView());
  }, []);

  useEffect(() => {
    if (!amtToWithdraw || isNaN(amtToWithdraw) || amtToWithdraw < MIN_WITHDRAWAL_AMT) {
      navigate(`/accounts/${applicationId}`);
      return;
    }
  }, [amtToWithdraw]);

  useEffect(() => {
    if (!modal?.isOpen && amtToWithdrawResp === 'withdrawalInProgress') {
      navigate(`/accounts/${applicationId}`);
    }
  }, [modal]);

  useEffect(() => {
    if (amtToWithdrawResp === 'withdrawalInProgress') {
      track(events.error('event', location.pathname, 'withdrawal in progress, please try after current withdrawal is complete', 'cash flow facility withdrawal'));
      openModal({
        title: 'Error',
        type: 'error',
        children: <div>withdrawal in progress, please try after current withdrawal is complete</div>,
        actions: [
          <Button
            style={{ display: 'flex', maxWidth: 230, width: '100%', justifyContent: 'center' }}
            key="confirmWithdrawal"
            onClick={handleClose}
          >
            Confirm
          </Button>
        ],
        onCloseModal: handleClose
      });
    }
  }, [amtToWithdrawResp]);

  const handleAcceptWithdrawalClick = async () => {
    track(events.creditFacilityWithdrawl.continue());
    closeModal();
    try {
      openLoader();
      const resp = await postCapitalFacilityWithdrawalQuote(amtToWithdraw,businessId,applicationId);

      setCfDetails(prev => ({
        ...prev,
        withdrawalEligibility: false
      }));

      const updatedApplicationStatus = [...appsList, resp];

      setAppList({ applications: updatedApplicationStatus });

      setOpenConfirm(true);
    } catch (error) {
      track(events.error('event', location.pathname, 'There was an error submitting your withdrawal', 'cash flow facility withdrawal'));
      closeModal();
      openModal({
        title: 'Error',
        children: <div>There was an error submitting your withdrawal.</div>,
        type: 'error',
        actions: [
          <Button key="withdrawalFailedClose" onClick={handleClose}>Close</Button>
        ],
        onCloseModal: handleClose
      });
    } finally {
      closeLoader();
    }
  };

  const handleClose = () => {
    closeModal();
    navigate(`/accounts/${applicationId}`);
  };

  const subHeadingText = () => {
    return (
      <>
        <span>
          <p>We have received your response.</p>
          <p>An email with your contract will be sent to:</p>
          <p>{email}</p>
        </span>
      </>
    );
  };

  const navigateTo = (path) =>
    navigate(path, {
      state: {
        returnPath: location.pathname
      }
    });

  const goToNextPage = () => {
    track(events.submitSuccessModal.submit());
    openLoader();
    setTimeout(() => {
      closeLoader();
      track(events.submitSuccessModal.pageView());
      navigateTo(`/applications/${businessId}`);
    }, 100);
  };

  const backClick = () => {
    track(events.creditFacilityWithdrawl.back());
    navigateTo(`/accounts/${applicationId}`);
  };

  /* TODO: Fix accordions on this screen and tabular data table not adhering to full width. */

  return (
    <div className={styles.container}>

      <div className={styles.titleContainer}>
        <div className={styles.titleHeading}>
         Cash Flow Facility withdrawal review
        </div>
      </div>
      <WithdrawalInfoSection />

      <FundingDetailsAccordion
        open={openSection}
        toggle={setOpenSection}
        amtToWithdrawResp={amtToWithdrawResp}
        onChangeAmountClick={() => track(events.creditFacilityWithdrawl.changeAmount())}
        businessId={businessId}
        applicationId={applicationId}
        isMobile={isMobile}
      />

      <RepaymentScheduleAccordion
        open={openSection}
        toggle={setOpenSection}
        amtToWithdrawResp={amtToWithdrawResp}
        isMobile={isMobile}
      />

      {isOpenConfirm && (
        <SubmitConfirmModal
          subHeading={subHeadingText()}
          onButtonClick={goToNextPage}
          heading='Thank You'
          buttonText='Got it'
        />
      )}
      <Footer
        leftTitle={'Back'}
        leftCallback={backClick}
        rightTitle={'Accept withdrawal'}
        rightCallback={handleAcceptWithdrawalClick}
      />
    </div>
  );
};
